(function () {

    angular
        .module('smartertoolsApp')
        .controller('supportController',
            [
                '$scope', '$timeout', '$location', 'supportService', 'notificationFactory', '$q', '$rootScope',
                supportController
            ]);

    function supportController($scope, $timeout, $location, supportService, notify, $q, $rootScope) {
        const vm = this;
        vm.allTicketsSearch = '';
        vm.filteredTickets = [];
        vm.totalFilteredItems = vm.filteredTickets ? vm.filteredTickets.length : 0;
        vm.ticketPaging = { page: 1, itemsPerPage: 10, pagedItems: {} };
        vm.isChanged = false;
        vm.selectedRdpType = null;
        vm.rdpPassChanged = false;
        vm.secondaryPassChanged = false;
        vm.webInterfacePassChanged = true;
        vm.goToOrConnectPassChanged = false;

        // Functions
        vm.doEditRsaa = doEditRsaa;
        vm.doStartRsaa = doStartRsaa;
        vm.doViewTicket = doViewTicket;
        vm.formatSupportLine = formatSupportLine;
        vm.goToPurchaseSupport = goToPurchaseSupport;
        vm.refresh = refresh;
        vm.selectRsaa = selectRsaa;
        vm.startRsaa = startRsaa;
        vm.startEmergencyTicket = startEmergencyTicket;
        vm.startTicket = startTicket;
        vm.valueChanged = valueChanged;
        vm.inputChecker = inputChecker;
        vm.sort = sort;
        vm.filter = filter;
        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();

            $rootScope.$on('ticketModalsController:submitted', (event, data) => {
                supportService.resetCache();
                refresh(true);
            });

            $rootScope.$on('ticketModalsController:showRsaa', (event, data) => {
                vm.newRsaa = { TicketNumber: data.ticketnumber };
                startRsaa();
                refresh(true);
            });
        }

        function sort(keyName) {
            vm.reverse = vm.sortKey !== keyName || !vm.reverse;
            vm.sortKey = keyName;
        };

        function filter() {
            $timeout(() => {
                vm.totalFilteredItems = vm.filteredInvoices ? vm.filteredInvoices.length : 0;
            }, 10);
        };

        function doEditRsaa() {
            if (vm.editRsaaForm.$invalid)
                return;
            supportService.editRsaa(vm.selectedRsaa)
                .then((results) => {
                    supportService.resetCache();
                    vm.refresh();
                });
        }

        function doStartRsaa() {
            if (vm.startRsaaForm.$invalid) {
                console.log(vm.startRsaaForm.$error);
                return;
            }
            if (!vm.newRsaa.AllowWebInterface && !vm.newRsaa.AllowRemoteDesktop) {
                notify.error('The purpose of an RSAA is to allow SmarterTools to connect to your system.  At least one connection option must be checked.');
                return;
            }
            supportService.startRsaa(vm.newRsaa)
                .then((results) => {
                    supportService.resetCache();
                    vm.refresh(true);
                    vm.modalPage = 'results';
                })
                .catch((err) => {
                    notify.error('There was an error creating the RSAA.  Please contact us for assistance.');
                    return;
                });
        }

        function doViewTicket(item) {
            angular.element(document.getElementById('ticketMsgModalCtlFinder')).scope().ticket.viewTicket(item);
        }

        function formatSupportLine(p) {
            return p.TicketNumber + ': ' + p.Subject + ' (' + moment(p.DateIssueStartedUtc).format('L') + ')';
        }

        function goToPurchaseSupport() {
            sessionStorage.setItem('addProduct_back',
                JSON.stringify({
                    url: $location.$$absUrl,
                    display: 'Technical Support'
                }));
            location.href = '/purchase/#/add/support';
        }

        function refresh(skipSpinner) {
            if (!skipSpinner) $scope.accountCtrl.isLoading += 4;
            $q
                .all([
                    supportService.getSupportInventory(),
                    supportService.getRsaas(),
                    supportService.getOpenSupportTickets(),
                    supportService.getAllTicketsWithRSAA()
                ])
                .then((arr) => {
                    vm.ticketSummary = arr[0];
                    vm.rsaAgreements = arr[1];
                    vm.openTickets = arr[2].Tickets;
                    vm.allTickets = arr[3].Tickets;

                    if (!skipSpinner) $scope.accountCtrl.isLoading -= 4;
                })
                .catch((err) => {
                    if (!skipSpinner) $scope.accountCtrl.isLoading -= 4;
                    notify.error('There was an error loading this page.  Please try again in a few minutes.  If this error persists, please contact us.');
                });
        }

        function selectRsaa(item) {
            vm.modalPage = 'step1';
            vm.selectedRsaa = item;
            vm.editRsaaForm.$setPristine();
            vm.editRsaaForm.$setUntouched();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('rsaa-edit')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function startEmergencyTicket() {
            bootstrap.Modal.getOrCreateInstance(document.getElementById('emergency-ticket-modal')).show();
        }

        function startTicket() {
            angular.element(document.getElementById('newTicketModalCtlFinder')).scope().ticket.startTicket();
        }

        function startRsaa() {
            if (vm.newRsaa == undefined)
                vm.newRsaa = {};
            //else
            //    vm.newRsaa.AllowWebInterface = true;
            vm.modalPage = 'step1';
            vm.tosAccepted = false;

            if (vm.startRsaaForm) {
                vm.startRsaaForm.$setPristine();
                vm.startRsaaForm.$setUntouched();
            }

            bootstrap.Modal.getOrCreateInstance(document.getElementById('rsaa-start')).show();
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function valueChanged(rdpType) {
            vm.isChanged = true;
            vm.selectedRdpType = rdpType;
        }

        function inputChecker(passType) {
            if (passType === 'rdp')
                vm.rdpPassChanged = true;
            if (passType === 'secondary')
                vm.secondaryPassChanged = true;
            if (passType === 'webInterface')
                vm.webInterfacePassChanged = true;
            if (passType === 'goToOrConnect')
                vm.goToOrConnectPassChanged = true;
        }
    }

})();